export const getTreeOfContentVisibility = state => state.treeOfContent.isExpanded; // eslint-disable-line
